import { render, staticRenderFns } from "./header_new.vue?vue&type=template&id=35c608ce&scoped=true&"
import script from "./header_new.vue?vue&type=script&lang=js&"
export * from "./header_new.vue?vue&type=script&lang=js&"
import style0 from "./header_new.vue?vue&type=style&index=0&id=35c608ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c608ce",
  null
  
)

export default component.exports